import { useWriteOffModal } from './WriteOffModal.hook';
import { InformationCircleOutlineIc } from '@dsch/dd-icons';
import { InfoIconButton } from './WriteOffModal.styled';
import { useTheme } from 'styled-components';

interface WriteOffModalInfoIconProps {
  onClickIcon?: () => void;
}

const WriteOffModalInfoIcon = (props: WriteOffModalInfoIconProps) => {
  const { onClickIcon } = props;
  const { openModal } = useWriteOffModal();
  const theme = useTheme();

  const handleIconClick = () => {
    openModal();
    onClickIcon?.();
  };

  return (
    <InfoIconButton
      onClick={handleIconClick}
      aria-label={'Open write-off information modal'}
    >
      <InformationCircleOutlineIc
        width="20"
        height="20"
        color={theme.donedeal.colors.BLUE}
      />
    </InfoIconButton>
  );
};

export { WriteOffModalInfoIcon };
